import { DetailTableProps } from '@/types/sensor'
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { Stack } from '@mui/system'
import { FC } from 'react'
import classes from './style.module.scss'

const SensorsTable: FC<DetailTableProps> = ({ rows, onEditItem }) => {
  // const handleEditItem = (id: string) => {
  //   onEditItem(id)
  // }

  return (
    <Stack flexGrow="1">
      <TableContainer
        component={Paper}
        elevation={0}
        className={classes.tableContainer}
      >
        <Table className={classes.table} aria-label="simple table">
          <TableHead className={classes.headTable}>
            <TableRow>
              <TableCell
                sx={{
                  minWidth: '10%',
                }}
                className={classes.cell}
              >
                ID
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '25%',
                  borderRight: '1px solid #D7D7D7',
                }}
                className={classes.cell}
              >
                Sensor Name
              </TableCell>
              <TableCell
                sx={{
                  minWidth: '25%',
                }}
              >
                Sensor Type
              </TableCell>

              <TableCell
                sx={{
                  width: '25%',
                }}
                className={classes.cell}
              >
                Source
              </TableCell>

              <TableCell
                sx={{
                  minWidth: '119px',
                }}
              >
                Action
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody sx={{ backgroundColor: 'common.white' }}>
            {rows.map((row, index) => (
              <TableRow key={index}>
                <TableCell
                  component="th"
                  scope="row"
                  className={classes.cellInColumn}
                >
                  {row.weatherLinkStationId}
                </TableCell>
                <TableCell
                  sx={{
                    borderRight: '1px solid #D7D7D7',
                  }}
                  className={classes.cellInColumn}
                >
                  {row.name}
                </TableCell>
                <TableCell>{row.category}</TableCell>
                <TableCell>{row.sensorSource}</TableCell>

                <TableCell className={classes.cellInColumn}>
                  <Stack direction="row" spacing="10px">
                    <Typography
                      className={classes.editBtn}
                      // onClick={() => handleEditItem(row.weatherLinkStationId)}
                    >
                      View
                    </Typography>
                  </Stack>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Stack>
  )
}

export default SensorsTable
